
export default function WhatIsMixExpress() {
  const benefits = [
    'Não altera o tom natural do cabelo',
    'É 85% orgânico',
    'Procedimento rápido — menos de 15 minutos',
    'Ideal para clientes que querem discrição, praticidade e naturalidade',
    'Perfeito para quem não quer (ou não pode) usar coloração tradicional'
  ];

  const scrollToForm = () => {
    const formSection = document.getElementById('cadastro-form');
    formSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="bg-[#2A2A2A] py-16 sm:py-24 px-4 sm:px-6 relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#EA9D00] rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-12 sm:mb-16">
          <span className="inline-flex items-center gap-3 sm:gap-4 flex-wrap">
            <span className="text-3xl sm:text-4xl">🚀</span>
            <span>O QUE É O MIX EXPRESS?</span>
          </span>
        </h2>

        <p className="text-white text-base sm:text-lg md:text-xl mb-8 sm:mb-12 max-w-4xl">
          O Mix Express é uma <strong className="text-[#EA9D00]">tecnologia inovadora</strong> para cobertura de fios brancos, que:
        </p>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 max-w-5xl mb-8 sm:mb-12">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className={`bg-white/95 rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 ${index % 2 === 1 ? 'sm:mt-10' : ''}`}
            >
              <div className="flex items-start gap-3 sm:gap-4">
                <div className="w-6 h-6 sm:w-7 sm:h-7 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#EA9D00] text-xl sm:text-2xl"></i>
                </div>
                <p className="text-[#2A2A2A] text-base sm:text-lg leading-relaxed">{benefit}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <button
            onClick={scrollToForm}
            className="bg-[#EA9D00] text-[#2A2A2A] font-bold text-sm sm:text-base md:text-lg px-6 sm:px-10 md:px-12 py-3 sm:py-4 rounded-full hover:bg-[#d89000] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            QUERO APRENDER NA LIVE GRATUITA
          </button>
        </div>
      </div>
    </section>
  );
}
